import axios from "axios";
import { clientConfig } from "../config";
import {loadCustomerFromSession,clearCustomerFromSession} from "../customHooks/useCustomer"
import { getCountryFromUrl, getLocaleByCountry, getCMSUrlPrefixByLocale, getLanguageByCountry, translate } from "./translator"
import * as testsRecorder from "./testsRecorder"
import { encryptWithPublicKey } from "./helpers";
import { djb2Hex8 } from "./QuestionnaireAnswersStorage";

export const MIDDLEWARES = {
  CUSTOMER_ID:"customer_id",
  CART_ORDER: "cart_order",
  GENERATE_FILE: "generate_file",
  ENCRYPTED_BODY: "encrypted_body"
}

// HL-11334: CloudFront A/B. Same uid always lands in the same arm; raising the percentage only moves
// users from the old host to the new one. Cookies are set on .doktor-abc.com so both hosts share them.
export function resolveApiUrl() {
  const { API_URL, CLOUDFRONT_API_URL, CLOUDFRONT_API_PERCENTAGE } = clientConfig;
  const uid = window.eventsTracking?.getData?.().uid;
  if (!CLOUDFRONT_API_URL || !CLOUDFRONT_API_PERCENTAGE || !uid) return API_URL;
  const bucket = parseInt(djb2Hex8(uid), 16) / 0x100000000; // 0 <= bucket < 1
  return bucket < CLOUDFRONT_API_PERCENTAGE ? CLOUDFRONT_API_URL : API_URL;
}

let initialized = false
const initAxios = ()=>{
  if (initialized){
    return
  }
  initialized = true

  //add retry layer
  axios.interceptors.response.use(undefined, (err) => {
    const { config, code } = err;
    if (!config || !config.retry) {
      return Promise.reject(err);
    }
    // retry while Network Error and there is no response
    if (code !== "ERR_NETWORK" || err.response ) {
      return Promise.reject(err);
    }
    config.retry -= 1;
    const delayRetryRequest = new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay || 100);
    });
    return delayRetryRequest.then(() => axios(config));
  });
}

//timers
axios.interceptors.request.use(function (config) {
  config.startTime = new Date().getTime()
  return config;
}, function (error) {
  return Promise.reject(error);
})

axios.interceptors.response.use(function (response) {
  response.config.endTime = new Date().getTime()
  response.duration = response.config.endTime - response.config.startTime
  return response;
}, function (error) {
  if (error.response){
    error.response.config.endTime = new Date().getTime();
    error.response.duration = error.response.config.endTime - error.response.config.startTime;
  }
  return Promise.reject(error);
})

// Intercept the response and set the new access token to the window.eventsTracking
// axios.interceptors.response.use(function (response) {
//   const newAccessToken = response.headers["x-new-access-token"];
//   if (newAccessToken) {
//     window.eventsTracking.setData("token", newAccessToken);
//   }
//   return response;

// }, function (error) {
//   if (error.response){
//     error.response.config.endTime = new Date().getTime();
//     error.response.duration = error.response.config.endTime - error.response.config.startTime;
//   }
//   return Promise.reject(error);
// })


function getConfig(middlewares) {
  let config = {
    headers: {'X-Amzn-Trace-Id':new Date().getTime() + "_" + Math.floor(Math.random() * 900000000)},
    withCredentials: true,
  };

  try{
    config.headers.ref_page = window.location.href
    config.headers.uid = window.eventsTracking.getData().uid
    config.headers.ts = new Date().getTime().toString()
    config.headers.ver = clientConfig.VERSION
  }
  catch(err){

  }

  if (middlewares && middlewares.includes(MIDDLEWARES.CUSTOMER_ID)){
    let customer = loadCustomerFromSession(); //get customer id and token
    if (customer && customer.customerID){
      config.headers["customer_id"] = customer.customerID;
      config.headers["token"] = customer.rememberToken || customer.token;
    }
  }

  if (middlewares && middlewares.includes(MIDDLEWARES.CART_ORDER)){

    const cartID = window.eventsTracking.getData(`cart_id`);
    const cartToken = window.eventsTracking.getData(`cart_token`);
    if (cartToken && cartID){
      config.headers["cart_id"] = cartID
      config.headers["cart_token"] = cartToken
    }
  }

  if (middlewares && middlewares.includes(MIDDLEWARES.GENERATE_FILE)){
      config.responseType = 'blob';
    }
    
  const languageID = window.eventsTracking.getData(`language`);
  if (languageID){
    config.headers["language_id"] = languageID;
  }
  return config;
}

let recordAllPages = false
const videoTrack = (response,requestConfig) =>{

  const MAX_DATA_LENGTH = 1000
  try{

    let event = {
      headers:response.config.headers,
      url: response.config.url,
      method:response.config.method,
      status:response.status,
      code:response.code,
      message:response.message
    }

    // multipart form ignores the Content-Type header of the request
    // we send it explicitly
    if (requestConfig?.headers["Content-Type"]){
      event.headers["Content-Type"] = requestConfig.headers["Content-Type"]
    }

    let requestData = response.config.data

    if (requestData){
      event.request_length = requestData.length

      // if (requestData.length < MAX_DATA_LENGTH){
      //   event.request_data = JSON.parse(requestData)
      // }
    }

    if (response.data){
      let dataString = JSON.stringify(response.data)

      event.response_length = dataString.length
      if (dataString.length < MAX_DATA_LENGTH){
        event.response_data = response.data
      }
    }

    // save the event to video tracking
    if (window.trackingV && window.trackingV.addEvent){
      window.trackingV.addEvent('http',event)
    }

    try{

      window.eventsTracking.track({
        e:'http_request',
        p:{
          trace_id:response.config.headers['X-Amzn-Trace-Id'],
          duration: response.duration,
          req_url: response.config.url,
          request_length:event.request_length,
          response_length:event.response_length,
          method:response.config.method,
          status:response.status,
          code:response.code
        }
      });
    }
    catch(err){
    }

    // save the event to test recorder
    if (clientConfig.ENV === "development"){

      // record this page or all pages / dependes in the url param
      if (window.location.href.includes("rec=all")){
        recordAllPages = true
      }


      if (window.location.href.includes("rec=page") || recordAllPages ){ 
        // add the full repsonse data that is being trimmed for video tracking
        let recordTestData = {...event}
        if (response.data){
          recordTestData.response_data = response.data
        }
        testsRecorder.addHttpEvent(recordTestData)
      }
    }
  }
  catch(err){
    window.clientLogger.warn("v track error",err)
  }
}

const handlerError = (error,errorStack,errorCallback) =>{

  if (error.response) {

    videoTrack(error.response)
    if (error.response.status === 401){
      clearCustomerFromSession();
      window.location.reload(false);
      return
    }

    if (error.response.status === 400 && ["cart_country_mismatch", "unsupported_locale"].includes(error.response.data?.status)) {
      window.eventsTracking.setData('last_order', '');
      window.eventsStorage.addToCookie('last_order_country', '');
      const country = getCountryFromUrl(window.location.pathname);
      const [cartLanguage, cartCountry] = (error.response.data.cartLocaleID || "").split("-");
      const language = cartLanguage || getLanguageByCountry(country);
      window.dispatchEvent(new CustomEvent("sticky-notification", { detail: {
        show: true,
        level: "error",
        showInfoIcon: true,
        autoFade: false,
        title: translate(language, "default", "StickyNotification/danger_title"),
        content: translate(language, "default", "StickyNotification/cart_country_mismatch"),
      }}));
      const pathSegments = window.location.pathname.split("/");
      const countryIndex = pathSegments.indexOf(country);
      let redirectUrl = `${clientConfig.MAIN_WEBSITE_URL}/${getCMSUrlPrefixByLocale(getLocaleByCountry(country))}`;
      if (cartCountry && countryIndex > 0) {
        pathSegments.splice(countryIndex, 2, cartCountry.toLowerCase(), cartLanguage);
        redirectUrl = pathSegments.join("/") + window.location.search;
      }
      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 5000);
      return
    }
  }
  else if (error.config){
    // if its axios error ( timeout, then there is no response)
    videoTrack(error)
  }

  if (error?.config?.headers && error.config.headers["X-Amzn-Trace-Id"]){
    error.trace_id = error.config.headers["X-Amzn-Trace-Id"];
  }
  
  error.stack = error.stack + " from " + errorStack.stack
  errorCallback && errorCallback(error);
  
}

export function getFromServer(relativePath,middlewares, additionalConfig = {}) {

  initAxios()
  let config = { ...getConfig(middlewares), ...additionalConfig };
  config.retry = 3;

  const call = `${resolveApiUrl()}/${relativePath}`;

  let stack = new Error()

  return new Promise (function (resolve, reject) {
    axios
    .get(call, config)
    .then((response) =>{
      if (response.headers["x-new-access-token"]) {
        window.eventsTracking.setData("token", response.headers["x-new-access-token"]);
      }

      videoTrack(response,config)
      resolve(response)
    })
    .catch(error => handlerError(error,stack,reject));
  })

}




export function get(url) {
  initAxios()
  return axios.get(url,{retry:3});
}


export function post(url, requestData, config) {
  initAxios()
  return axios.post(url, requestData, config)
}

let lastPostedRequests = {}; // Record<string, {timestamp: Number, response: any, status: "pending" | "resolved" | "rejected"}>

let publicKeyVersion = null;
let publicKey = null;


let dedupBypassCounter = 0;

export function postToServer(
  relativePath,
  data,middlewares,additionalConfig = {}
) {
  const { skipDedup, ...axiosConfig } = additionalConfig;
  let config = { ...getConfig(middlewares), ...axiosConfig };
  axios.defaults.withCredentials = true;

  // The 300ms de-dup below is keyed by path only. Callers that legitimately POST the same path
  // with different bodies in quick succession (search + pagination) opt out with skipDedup, which
  // gives each call its own key instead of sharing the previous response.
  const dedupKey = skipDedup ? `${relativePath}#${++dedupBypassCounter}` : relativePath;

  let stack = new Error()

  return new Promise (function (resolve, reject) {


    const cachedResponseIsExpired = !lastPostedRequests[dedupKey] || new Date().getTime() - lastPostedRequests[dedupKey].timestamp > 300;
    if (cachedResponseIsExpired) {

      lastPostedRequests[dedupKey] = {
        timestamp: new Date().getTime(),
        response: null,
        status: "pending",
        resolveCallbacks: [resolve],
        rejectCallbacks:[reject]
      }


    let prepareRequest = Promise.resolve(data);
    
    if (middlewares?.includes(MIDDLEWARES.ENCRYPTED_BODY)){

      if (!publicKeyVersion || !publicKey){
        prepareRequest = getFromServer("auth/local/public")
            .then((response) => {
              const { publicKeyVersion, publicKey } = response.data;
              config.headers["x-encrypted"] = "true";
              config.headers["x-encrypted-version"] = publicKeyVersion;
              return encryptWithPublicKey(publicKey, JSON.stringify({...data, requestedAt: new Date().getTime()}));
            })
      } else {
        config.headers["x-encrypted"] = "true";
        config.headers["x-encrypted-version"] = publicKeyVersion;
        prepareRequest = Promise.resolve(encryptWithPublicKey(publicKey, JSON.stringify({...data, requestedAt: new Date().getTime()})));
      }
    }


    prepareRequest
    .then((requestData) => post(`${resolveApiUrl()}/${relativePath}`, requestData, config))
    .then((response) =>{
      if (response.headers["x-new-access-token"]) {
        window.eventsTracking.setData("token", response.headers["x-new-access-token"]);
      }
      
      videoTrack(response,config)
      lastPostedRequests[dedupKey].status = "resolved"
      lastPostedRequests[dedupKey].response = response
      lastPostedRequests[dedupKey].resolveCallbacks.forEach((resolveFunc) => resolveFunc(response))
      lastPostedRequests[dedupKey].resolveCallbacks = []
    })
    .catch(error => {
      lastPostedRequests[dedupKey].rejectCallbacks.forEach((rejectFunc) => rejectFunc(error))
      handlerError(error,stack,reject)
    });


  } else if (lastPostedRequests[dedupKey].status === "pending"){
    lastPostedRequests[dedupKey].resolveCallbacks.push(resolve)
    lastPostedRequests[dedupKey].rejectCallbacks.push(reject)
  }
  // check if the item is in cached
  else{
    resolve(lastPostedRequests[dedupKey].response)
  }
  })

}





export function postFileToServer(
  relativePath,
  data,
  middlewares
) {
  let config = getConfig(middlewares);
  axios.defaults.withCredentials = true;

  config.headers["Content-Type"] = "application/octet-stream";

  let stack = new Error()

    return new Promise (function (resolve, reject) {
      return post(`${resolveApiUrl()}/${relativePath}`, data, config)
      .then((response) =>{
        videoTrack(response,config)
        resolve(response)
      })
      .catch(error => handlerError(error,stack,reject));
    })
}

export function postMultiPartsToServer(
  relativePath,
  data,
  files,
  middlewares
) {
  var formData = new FormData();
  
  files.forEach(file=>{
    formData.append("files", new File([file.binary_data], file.filename, { type: file.type }));
  });

  formData.append("document", JSON.stringify(data));

  let config = getConfig(middlewares);
  axios.defaults.withCredentials = true;

  config.headers["Content-Type"] = "multipart/form-data"

  let stack = new Error()

    return new Promise (function (resolve, reject) {
      return post(`${resolveApiUrl()}/${relativePath}`, formData, config)
      .then((response) =>{
        if (response.headers["x-new-access-token"]) {
          window.eventsTracking.setData("token", response.headers["x-new-access-token"]);
        }

        videoTrack(response,config)
        resolve(response)
      })
      .catch(error => handlerError(error,stack,reject));
    })
}
